import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/transcript/downloadTranscript"));

const DownloadTranscript = () => {
  return (
    <Layout pageHeading="Transcript">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default DownloadTranscript;